import type { MosaicNode } from 'react-mosaic-component';

export const ALL_TILE_IDS = [
  'at-a-glance',
  'uncertainty',
  'timeline',
  'evolution',
  'map',
] as const;

export type TileId = (typeof ALL_TILE_IDS)[number];

export const TILE_TITLES: Record<TileId, string> = {
  'at-a-glance': 'At a Glance',
  uncertainty: 'Uncertainty',
  timeline: 'Timeline',
  evolution: 'Evolution',
  map: 'Map',
};

export const DEFAULT_MOSAIC_TREE: MosaicNode<TileId> = {
  direction: 'row',
  splitPercentage: 40,
  first: {
    direction: 'column',
    first: 'timeline',
    second: {
      direction: 'row',
      first: 'uncertainty',
      second: 'evolution',
    },
  },
  second: {
    direction: 'column',
    splitPercentage: 63,
    first: 'map',
    second: 'at-a-glance',
  },
};

export const MOSAIC_STORAGE_KEY = 'sip-mosaic-layout' as const;

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';
